import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { LogoutDirective } from '@app/core/auth/directives/logout.directive';
import { UserInToken } from '@app/entities/users/interfaces/user-in-token';
import { AuthSelectors } from '@app/store';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-account-profile-block-page',
  templateUrl: './account-profile-block.component.html',
  styleUrls: ['./account-profile-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, AsyncPipe, LogoutDirective],
})
export class AccountProfileBlockComponent {
  constructor(
    private store: Store,
    protected router: Router,
  ) {}

  protected currentUser$: Observable<UserInToken | undefined> =
    this.store.select(AuthSelectors.currentUser);

  getUserName(user: UserInToken): string {
    return [user.name, user.surname].filter(Boolean).join(' ');
  }

  getAddress(user: UserInToken): string {
    return [
      [
        [user.address, user.address_info].filter(Boolean).join('-'),
        user.zip_code,
      ]
        .filter(Boolean)
        .join(', '),
      [user.city, user.country].filter(Boolean).join(', '),
    ]
      .filter(Boolean)
      .join(', <br />');
  }
}
